import React from "react";
import "./style.scss";

export interface LayoutProps {
    children: React.ReactNode;
    header?: React.ReactChild;
    withMargin?: boolean;
    withPadding?: boolean;
}

const Layout = (props: LayoutProps) => {
    return (
        <div className={`vapor-layout ${props.withMargin ? "withMargin" : ""}`}>
            {props.header}
            <div
                className={`vapor-layout-children ${props.withPadding ? "withPadding" : ""}`}
            >
                {props.children}
            </div>
        </div>
    );
};

Layout.defaultProps = {
    withMargin: false,
    withPadding: true,
};

export default Layout;
